import { useState, useEffect } from 'react';
import { memberDetailService } from '../services/memberDetail.service';
import type { MemberDetail, MemberLog } from '../types/memberDetail.types';

export function useMemberDetail(id: string | null) {
  const [member, setMember] = useState<MemberDetail | null>(null);
  const [logs, setLogs] = useState<MemberLog[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;

    async function fetchData() {
      try {
        setIsLoading(true);
        const [memberData, logsData] = await Promise.all([
          memberDetailService.getMemberById(id),
          memberDetailService.getMemberLogs(id)
        ]);
        setMember(memberData);
        setLogs(logsData);
      } catch (err: any) {
        setError(err.message || 'Lỗi khi tải thông tin thành viên');
      } finally {
        setIsLoading(false);
      }
    }

    fetchData();
  }, [id]);

  return { member, logs, isLoading, error };
}
